module.exports = __webpack_public_path__ + "static/img/图层590拷贝.0b8bee3b.png";